<link href="./delete-table-description-dialog.scss" rel="stylesheet" />

<div class="warning-icon">
  <i class="fa-solid fa-triangle-exclamation"></i>
</div>

<h2 mat-dialog-title>Remove Table</h2>

<mat-dialog-content>
  <div class="confirmation-text">
    Are you sure you want to remove this table?
  </div>

  <mat-card class="warning-card">
    <div>
      <b class="warning-label">Warning:</b>
      <p class="warning-message">
        By removing this table, you won't be able to see this table in this
        filtered metadata.
      </p>
    </div>
  </mat-card>
</mat-dialog-content>

<mat-dialog-actions>
  <button matButton mat-dialog-close class="btn generate-btn cancel-button" (click)="onCancel()">
    No, Cancel
  </button>
  <button matButton mat-dialog-close cdkFocusInitial class="btn btn-danger generate-btn remove-button" (click)="onOk()">
    Yes, Remove
  </button>
</mat-dialog-actions>